<template>
  <div class="base-info-container">
    <el-card>
      <template #header>
        <TitleItem title="基本信息" />
      </template>
      <el-form ref="baseInfoForm" :model="baseInfoModel" :rules="rules" label-width="125px">
        <el-form-item label="商品分类" required>
          <template v-if="cateModel">
            <span>{{ cateModel.classificationFullName }}&nbsp;&nbsp;</span>
            <el-button type="text" @click="changeCate"> 修改类目</el-button>
          </template>
          <el-button v-else type="text" @click="changeCate">选择类目</el-button>
          <p class="cate-tips">准确选择货品分类有助于完善货品信息和精准推送到商城分类</p>
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input style="width: 453px" v-model="baseInfoModel.name" maxlength="30" placeholder="请输入商品名称(至多30字)"></el-input>
        </el-form-item>
        <el-form-item v-if="isShowOA && qlwGoodsName && qlwGoodsName[0] && qlwGoodsName[0].name" label="代号名称">
          {{ qlwGoodsName[0].name }}
        </el-form-item>
        <el-form-item label="卖点分享">
          <el-input style="width: 453px" v-model="baseInfoModel.shareInfo" maxlength="30" placeholder="请填写卖点分享"></el-input>
        </el-form-item>
        <el-form-item label="自定义分类">
          <el-select v-model="baseInfoModel.goodsType" placeholder="请选择自定义分类">
            <el-option v-for="cateItem in customCateList" :label="cateItem.name" :value="cateItem.shopDecorateId" :key="cateItem.shopDecorateId"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="isShowOA">
          <el-form-item label="是否企联网货品" required>
            <el-radio-group v-model="baseInfoModel.isoa">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <span class="cate-tips" v-if="baseInfoModel.isoa == 0"
              >&nbsp;&nbsp;&nbsp;修改为非企联网商品后,下次编辑请不要改动规格属性,避免企联网代号关系错乱</span
            >
          </el-form-item>
        </template>
      </el-form>
    </el-card>
    <SelectCateDialog v-if="showSelectCate" :showSelectCate.sync="showSelectCate" />
  </div>
</template>

<script>
import { getGoodsShopCategory } from "@/api/publishGoods/publishGoods";
import { createNamespacedHelpers } from "vuex";
import TitleItem from "./TitleItem.vue";
import SelectCateDialog from "./SelectCateDialog.vue";

const { mapState } = createNamespacedHelpers("publishGoods/publishGoods");

export default {
  components: {
    TitleItem,
    SelectCateDialog,
  },
  data() {
    return {
      showSelectCate: false,
      isShowOA: false,
      customCateList: [],
      baseInfoModel: {
        name: "",
        goodsType: "",
        isoa: 0,
        shareInfo: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["cateModel", "goodsDetail", "spuId", "shopConfig", "qlwGoodsName"]),
  },
  created() {
    this.loadGetGoodsShopCategory();
  },
  watch: {
    goodsDetail(newVal) {
      console.log("newVal", newVal);
      this.$store.dispatch("publishGoods/publishGoods/setCateModel", {
        classificationFullName: newVal.categoryAxis,
        id: newVal.firstSku.categoryId,
        axis: newVal.firstSku.axis,
      });
      this.baseInfoModel.name = newVal.firstSku.name;
      this.baseInfoModel.goodsType = newVal.shopClassifyId;
      this.baseInfoModel.isoa = newVal.firstSku.isoa;
      this.baseInfoModel.shareInfo = newVal.shareInfo;
    },
    shopConfig(newVal) {
      //新增商品时,不展示企联网
      if (this.spuId) {
        this.isShowOA = newVal.isoa == 1 && newVal.shopDtlEntity.isSetGoodsOa == 1;
      }
    },
    "baseInfoModel.isoa": {
      handler(newVal) {
        this.$store.dispatch("publishGoods/publishGoods/setStoreIsOa", Boolean(newVal));
      },
    },
  },
  methods: {
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
    },
    changeCate() {
      this.showSelectCate = true;
    },
    async subMitCheck() {
      if (!this.cateModel) {
        this.$message.error("请选择商品分类");
        return;
      }
      try {
        await this.$refs.baseInfoForm.validate();

        const baseInfoObj = {
          categoryId: this.cateModel.id,
          axis: this.cateModel.axis,
          name: this.baseInfoModel.name,
          goodsType: this.baseInfoModel.goodsType,
          isoa: this.baseInfoModel.isoa,
          shareInfo: this.baseInfoModel.shareInfo,
        };

        return baseInfoObj;
      } catch (error) {
        this.$message.error("请填写商品名称");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-info-container {
  padding-top: 20px;
  .cate-tips {
    color: grey;
    line-height: 1.2;
    font-size: 12px;
  }
}
</style>
